import { Box, BoxProps, Button, colors } from "@biblioteksentralen/react";
import { isProduction } from "@libry-content/common";
import { isObject as isPlainObject } from "radash";
import { PropsWithChildren } from "react";
import { JsonView, defaultStyles } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import { useToggle } from "react-use";
import { ModalContainer } from "../../components/ModalContainer";

const JsonStyle = ({ children }: PropsWithChildren) => (
  <Box sx={{ div: { background: "white" }, "[role=listitem],[role=list]": { marginBottom: "0.5rem" } }}>{children}</Box>
);

const shouldInitiallyExpand = (level: number, value: unknown) => {
  if (Array.isArray(value) && value.length === 0) return false;
  if (!!value && typeof value === "object" && isPlainObject(value) && Object.keys(value).length === 0) return false;
  return true;
};

const RawData = ({ data }: { data: object }) => (
  <JsonStyle>
    <JsonView data={data} style={defaultStyles} shouldInitiallyExpand={shouldInitiallyExpand} />
  </JsonStyle>
);

export const CordataDevInfo = ({ data, title, ...boxProps }: { data: object; title: string } & BoxProps) => {
  const [showDevInfo, toggleDevInfo] = useToggle(false);

  if (isProduction) return null;

  return (
    <Box {...boxProps}>
      <Button onClick={toggleDevInfo} variant="secondary" size="xs" background={colors.white}>
        {/* eslint-disable-line i18next/no-literal-string */}
        Dev info: {title}
      </Button>
      <ModalContainer
        heading={`Dev info: ${title}`}
        isOpen={showDevInfo}
        onClose={toggleDevInfo}
        scrollBehavior="inside"
        modalContentProps={{ padding: "1rem", maxWidth: "min(90%, 50rem)" }}
      >
        <RawData data={data} />
      </ModalContainer>
    </Box>
  );
};
